import { FormInput } from "@4uhub/lib4uhub";
import { Grid, FormHelperText } from "@mui/material";
import { memo } from "react";
import { useTranslation } from "react-i18next";
import { useAutomationRules } from "../../../../../../../store/contexts/AutomationRulesContext";

const translationPath = "components.messages.";

export const OriginsField = memo(() => {
  const { t } = useTranslation();

  const { automation } = useAutomationRules();

  if (
    !automation ||
    !automation.code ||
    !["4", "12", "13", "14"].includes(automation.code)
  )
    return null;

  return (
    <Grid item xs={12} sm={12}>
      <FormInput
        size="small"
        name="origin"
        fullWidth
        label={t(translationPath + "origin") || "origin"}
      />
      <FormHelperText>
        {t(translationPath + "originMessageHelper")}
      </FormHelperText>
    </Grid>
  );
});
